import React from 'react'
import {useNavigate} from 'react-router-dom'
import {SignInForm} from '../../components/auth'
import {AuthComplete} from '../../components/auth/types'
import {useAnalytics} from '../../lib/analytics/analytics'
import {Authenticator} from '../../lib/cognito'
import {toRelativeURL} from '../../lib/helpers'
import {AuthLayout} from './layout'

interface SignInProps {
  auth: Authenticator
}

export const SignIn = ({auth}: SignInProps) => {
  const navigate = useNavigate()
  const analytics = useAnalytics()

  const onComplete: AuthComplete = (state, credentials) => {
    if (state === 'confirm') {
      navigate(`/signup/confirm?username=${credentials.username}`)
    }
    analytics.trackNoOrg({
      event: 'Logged into workbench',
      properties: {
        email: credentials.username,
        category: 'general'
      }
    })
  }

  return (
    <AuthLayout>
      <SignInForm
        auth={auth}
        onComplete={onComplete}
        // Using un/pw: we won't leave the URL anyway. Redirect will be a no-op.
        // Using SSO: we will visit cognito and on return we want to go back to our url.
        redirectToPath={toRelativeURL(window.location.href)}
      />
    </AuthLayout>
  )
}
